import { Box, Button, Dialog, DialogActions, Stack, Typography } from "@mui/material";
import ImageUploadHandler from "components/PimDashboard/CommonComponents/ImageUploadHandler/ImageUploadHandler";
import { useState } from "react";

const formatLabel = (value = "") => value.split("_").join(" ").toLowerCase();

const AddViewImagesModal = ({ modalOpen, setModalOpen, submitFunction, defaultImages, view, channel }) => {
	const [newImages, setNewImages] = useState(defaultImages?.length ? defaultImages : []);
	const [mainImageIndex, setMainImageIndex] = useState(0);

	const handleCloseModal = () => {
		setModalOpen(false);
	};
	const handleFormSubmit = async (e) => {
		e.preventDefault();

		if (typeof submitFunction === "function") {
			const updatedFormat = newImages.map((row) => {
				return {
					file: row.file,
					url: row.url,
					channel,
					view,
				};
			});
			console.log(updatedFormat, "dsmnbkd,nsas");
			let result = await submitFunction(updatedFormat);
			if (result) {
				setModalOpen(false);
				setNewImages([]);
			}
		}
	};
	return (
		<Dialog fullWidth maxWidth="md" open={modalOpen} onClose={handleCloseModal} component="form" onSubmit={handleFormSubmit}>
			<Stack>
				<Box p={2} pb={0}>
					<Typography variant="h6">Upload SKU Images</Typography>
					<Typography variant="body2" color="text.secondary" textTransform="capitalize">
						{formatLabel(channel)} / {formatLabel(view)}
					</Typography>
				</Box>
				<ImageUploadHandler
					images={newImages}
					setImages={setNewImages}
					mainImageIndex={mainImageIndex}
					setMainImageIndex={setMainImageIndex}
					disableButtons={true}
				/>
			</Stack>

			<DialogActions>
				<Button variant="outlined" onClick={handleCloseModal}>
					Cancel
				</Button>
				<Button autoFocus variant="contained" sx={{ mr: 1 }} type="submit">
					Save
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default AddViewImagesModal;
